// import React from "react";
// import FooterLogo from "../../assets/FooterLogo.svg"
// import {
//   Box,
//   Container,
//   Divider,
//   Grid,
//   IconButton,
//   Stack,
//   Typography,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import FooterIconFb from "../../assets/FooterIconFB.png";
// import FooterIconTwitter from "../../assets/FooterIconTwitter.png";
// import FooterIconInsta from "../../assets/FooterIconInsta.png";
// import { makeStyles } from "@mui/styles";
// import FooterDesign from "../../assets/FooterDesign.svg";

// const useStyles = makeStyles({
//   footerBGS: {
//     backgroundColor: "#3d065f",
//     color: "white",
//     backgroundImage: "url('/images/footerBg.png')",
//     backgroundRepeat: "no-repeat",
//     backgroundSize: "10%",
//     backgroundPosition: "left 15% bottom",
//   },

// });

// function Footer() {
//   const classes = useStyles();
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   return (
//     <>
//       <Box >
//         <Container className={classes.footerBGS} maxWidth="xl" >
//           <Grid container>
//             <Grid
//               item
//               container
//               xs={11}
//               md={11}
//               mt={12}
//               mb={8}
//             // px={{ xs: 0 }}
//             // my={{ xs: 0, md: 8 }}


//             >
//               <Grid item md={6} xs={12}>
//                 {/* <Box display="flex" alignItems="left" paddingLeft={0} marginLeft={isSmallScreen ? 2 : 8} position="relative">
//                   <a href="/" style={{ textDecoration: "none", position: 'relative', zIndex: 2 }}>
//                     <img src={FooterLogo} className="footerlogo" alt="FooterLogo" height={24} width={117} />
//                   </a>

//                   <img
//                     src={FooterDesign}
//                     alt=""
//                     style={{
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover',
//                       zIndex: 1, 
//                     }}
//                   />


//                 </Box> */}
//                 <Box display="flex" alignItems="left" paddingLeft={0} marginLeft={isSmallScreen ? 2 : 8} position="relative" width="auto" height="auto">
//                   <Box position="relative" zIndex={2}>
//                     <a href="/" style={{ textDecoration: "none", position: 'relative', zIndex: 2 }}>
//                       <img src={FooterLogo} className="footerlogo" alt="FooterLogo" height={24} width={117} />
//                     </a>
//                   </Box>
//                   <Box position="absolute" top={0} left={0} width="100%" height="100%" zIndex={1}>
//                     <img
//                       src={FooterDesign}
//                       alt="Footer Design"
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover',
//                       }}
//                     />
//                   </Box>
//                 </Box>
//               </Grid>

//               <Grid item md={2} sm={12} xs={12} my={{ xs: 1 }}>

//               </Grid>
//               <Grid item md={2} sm={12} xs={12} my={{ xs: 1 }}>

//               </Grid>
//               <Grid item md={1} sm={11} xs={11}
//                 my={{ md: 1 }}
//                 ml={2}
//               >
//                 <Box>
//                   {<Typography
//                     variant="body2"
//                     fontWeight={"bold"}
//                     fontFamily={"inter"}
//                   >
//                     Connect with us
//                   </Typography>}
//                   <Stack direction={"row"} spacing={1} mt={1}>
//                     <Link to="/facebook" style={{ textDecoration: 'none' }}>
//                       <IconButton onClick={() => window.open("https://www.facebook.com/profile.php?id=100089106098684", "_blank")}>
//                         <img src={FooterIconFb} alt="Facebook" />
//                       </IconButton>
//                     </Link>

//                     <Link to="/twitter" style={{ textDecoration: 'none' }}>
//                       <IconButton onClick={() => window.open("https://twitter.com/ReachKramasoft", "_blank")}>
//                         <img src={FooterIconTwitter} alt="Twitter" />
//                       </IconButton>
//                     </Link>

//                     <Link to="/instagram" style={{ textDecoration: 'none' }}>
//                       <IconButton onClick={() => window.open("https://www.instagram.com/kramasoft_mortgagespecialist/", "_blank")}>
//                         <img src={FooterIconInsta} alt="Instagram" />
//                       </IconButton>
//                     </Link>
//                   </Stack>
//                 </Box>
//               </Grid>
//             </Grid>
//             <Grid item md={11} xs={11} mt={{ xs: 12, md: 1 }}>
//               <Divider sx={{ backgroundColor: "white", ml: { xs: 2, md: 8 } }}
//               />
//             </Grid>



//             <Grid item container xs={12} md={12} my={5} mb={12}>
//               <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
//                 <Link to="/borrower-portal/disclaimer" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
//                   <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Disclaimers</Typography>
//                 </Link>
//               </Grid>
//               <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
//                 <Link to="/borrower-portal/terms-of-use" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>

//                   <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Terms of Use</Typography>
//                 </Link>
//               </Grid>

//               <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
//                 <Link to="/borrower-portal/privacy-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
//                   <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Privacy Policy</Typography>
//                 </Link>
//               </Grid>

//               <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
//                 <Link to="/borrower-portal/california-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
//                   <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>California Policy</Typography>
//                 </Link>
//               </Grid>
//               <Grid item md={1} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
//                 <Link to="/borrower-portal/security-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
//                   <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Security</Typography>
//                 </Link>
//               </Grid>

//             </Grid>
//           </Grid>
//         </Container>
//       </Box >
//     </>
//   );
// }

// export default Footer;
import React from "react";
import { Box, Container, Divider, Grid, IconButton, Stack, Typography, } from "@mui/material";
import FooterIconFb from "../../assets/FooterIconFB.png";
import FooterIconTwitter from "../../assets/FooterIconTwitter.png";
import { makeStyles } from "@mui/styles";
import Logo from "../../assets/AmitaSoftF.svg";
import FooterIconLinkdin from "../../assets/FooterIconLinkdin.png";
import { Link } from "react-router-dom";
import { KSFacebookIcon, KSLinkedInIcon, KSTwitterIcon } from "../../icons/custome-icon";
import { aboutUsUrl, socialLinks } from "../../config/siteUrls";



const customStyle = makeStyles({
  footerBG: {
    backgroundColor: "#373973",
    color: "white",
    backgroundImage: "url('/images/footerBg.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "10%",
    backgroundPosition: "left 15% bottom",
  },
  curPointer: {
    cursor: "pointer"
  }
});

function Footer({ setPage }) {
  const classes = customStyle();

  return (
    <>

      <Box className={classes.footerBG}>
        <Container maxWidth="xl">
          <Grid container>
            <Grid
              item
              container
              xs={12}
              md={12}
              px={{ xs: 2 }}
              my={{ xs: 5, md: 15 }}
              ml={{ xs: 0, md: 6 }}
            >

              <Grid item md={8} xs={12}>
                <Box
                  display="flex"
                  flexGrow={0}
                  alignItems="center"
                  sx={{ textDecoration: 'none' }}
                >
                  <Link
                    to="/borrower-portal"
                    onClick={() => window.scrollTo(0, 0)}
                    style={{ textDecoration: 'none' }}
                  >
                    <img src={Logo} width="150px" alt="logo" />
                  </Link>
                </Box>
              </Grid>

              <Grid item md={2} sm={12} xs={12} mt={{ xs: 3, md: 0 }}>
                <Typography
                  variant="body2"
                  fontWeight="bold"
                  fontFamily="inter"
                  component="a"
                  href={aboutUsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  About us
                </Typography>
              </Grid>


              <Grid item md={2} sm={12} xs={12} mt={{ xs: 3, md: 0 }}>
                <Box>
                  <Typography
                    variant="body2"
                    fontWeight={"bold"}
                    fontFamily={"inter"}
                  >
                    Connect with us
                  </Typography>
                  <Stack direction={"row"} mt={1}>
                    <IconButton sx={{ paddingLeft: 0 }} aria-label="Linkedin.com" onClick={() => window.open(socialLinks.linkedIn, "_blank", "noopener,noreferrer")}>
                      <KSLinkedInIcon sx={{ fontSize: '35px' }} />
                    </IconButton>
                    <IconButton aria-label="Facebook.com" onClick={() => window.open(socialLinks.facebook, "_blank", "noopener,noreferrer")}>
                      <KSFacebookIcon sx={{ fontSize: '35px' }} />
                    </IconButton>
                    <IconButton aria-label="X.com" onClick={() => window.open(socialLinks.x, "_blank", "noopener,noreferrer")}>
                      <KSTwitterIcon sx={{ fontSize: '35px' }} />
                    </IconButton>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
            <Grid item md={11} sm={11} xs={10} ml={{ xs: 2, md: 8 }}>
              <Divider sx={{ backgroundColor: "white" }} />
            </Grid>

            <Grid item container xs={12} md={12} my={5}>
              <Grid item md={2} sm={2} xs={6} my={{ xs: 1, md: "none" }} ml={{ xs: 2, md: 8 }}>
                <Link to="/borrower-portal/disclaimer" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" className={classes.curPointer}>Disclaimers</Typography>
                </Link>
              </Grid>
              <Grid item md={2} sm={2} xs={6} my={{ xs: 1, md: "none" }} ml={{ xs: 2, md: 4 }}>
                <Link to="/borrower-portal/terms-of-use" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" className={classes.curPointer}>Terms of Use</Typography>
                </Link>
              </Grid>
              <Grid item md={2} sm={2} xs={6} my={{ xs: 1, md: "none" }} ml={{ xs: 2, md: 4 }}>
                <Link to="/borrower-portal/privacy-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" className={classes.curPointer}>Privacy Policy</Typography>
                </Link>
              </Grid>
              <Grid item md={2} sm={2} xs={6} my={{ xs: 1, md: "none" }} ml={{ xs: 2, md: 4 }}>
                <Link to="/borrower-portal/california-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" className={classes.curPointer}>California Policy</Typography>
                </Link>
              </Grid>
              <Grid item md={2} sm={2} xs={6} my={{ xs: 1, md: "none" }} ml={{ xs: 2, md: 4 }}>

                <Link to="/borrower-portal/security-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" className={classes.curPointer}>Security</Typography>
                </Link>

              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Footer;
